import { Dayjs } from 'dayjs';
import * as React from 'react';
import { useMemo, useState } from 'react';

import Button from '@/components/elements/Button/BaseButton';
import DigestModal from '@/components/layouts/Modal/Digest';
import { Grade } from '@/lib/apollo/types/gen/graphql';
import { Velodrome } from '@/modelTypes';
import { toHalfWidth } from '@/utility/utils';

export interface DigestButtonProps {
  velodrome: Velodrome;
  heldDate: Dayjs;
  raceRank: string;
  raceNum: number;
  device: 'pc' | 'sp';
}

export const alternativeGrade = (
  code: number | undefined,
  heldDate: Dayjs,
): string => {
  if (code && code === 31) {
    // 「2023-10-02 ～ 04」の「松戸競輪：31」の場合「グレードコード：01」を返却する
    const targetDates = ['2023-10-02', '2023-10-03', '2023-10-04'];
    if (targetDates.includes(heldDate.format('YYYY-MM-DD'))) {
      return '01';
    }
  }
  return '';
};

export const DigestButton: React.FC<DigestButtonProps> = ({
  velodrome,
  heldDate,
  raceRank,
  raceNum,
  device,
}) => {
  const [play, setPlay] = useState<boolean>(false);
  const raceRankCode = useMemo(() => {
    const alternative = alternativeGrade(velodrome.code, heldDate);
    if (alternative !== '') {
      return alternative;
    }

    switch (toHalfWidth(raceRank)) {
      case Grade.F2:
        return '01';
      case Grade.F1:
        return '02';
      case Grade.G3:
        return '03';
      case Grade.G2:
        return '04';
      case Grade.G1:
        return '05';
      case Grade.Gp:
        return '06';
      default:
        break;
    }
    return '';
  }, [raceRank]);

  const raceNumStr = useMemo(() => {
    const temp = '00' + raceNum;
    return temp.substring(temp.length - 2);
  }, [raceNum]);

  const videoUrl = useMemo(() => {
    if (velodrome) {
      const heldDateStr = heldDate.format('YYYYMMDD');
      return `https://wm.st.keirin.jp/wm-keirin${velodrome.code}/${heldDateStr}-${velodrome.code}-${raceRankCode}-${raceNumStr}-01`;
    }
    return '';
  }, [velodrome, raceRankCode, raceNumStr]);

  return (
    <>
      {velodrome && (
        <>
          <DigestModal
            isOpen={play}
            handleClose={() => setPlay(false)}
            videoUrl={videoUrl}
          />
          <Button
            size={device === 'pc' ? 's' : 'xs'}
            bgColor="secondary"
            outline
            width={device === 'pc' ? '100%' : '88px'}
            height={device === 'pc' ? '46px' : '36px'}
            radius={device === 'pc' ? 'm' : 's'}
            onClick={() => {
              setPlay(!play);
            }}
          >
            ダイジェスト
          </Button>
        </>
      )}
    </>
  );
};

export default DigestButton;
